<template>
  <ul
    v-if="activeFilters.length"
    class="c-active-filters l-flex l-flex--justify-start"
  >
    <button
      role="group"
      class="c-active-filters-group"
      aria-label="size"
    >
      <li
        v-for="(filterValue, key) in filterValues.size"
        :key="`${key}`"
        aria-required="true"
        class="c-active-filters__filter"
      >
        <button
          class="c-active-filters__pill t-heading-9"
          @click="removeFilter(filterValue)"
        >
          {{ filterValue | label(filters) }}
        </button>
      </li>
    </button>
    <button
      role="group"
      class="c-active-filters-group"
      aria-label="color"
    >
      <li
        v-for="(filterValue, key) in filterValues.color"
        :key="`${key}`"
        aria-required="true"
        class="c-active-filters__filter"
      >
        <button
          class="c-active-filters__pill t-heading-9"
          @click="removeFilter(filterValue)"
        >
          {{ filterValue | label(filters) }}
        </button>
      </li>
    </button>
    <button
      role="group"
      class="c-active-filters-group"
      aria-label="width"
    >
      <li
        v-for="(filterValue, key) in filterValues.width"
        :key="`${key}`"
        aria-required="true"
        class="c-active-filters__filter"
      >
        <button
          class="c-active-filters__pill t-heading-9"
          @click="removeFilter(filterValue)"
        >
          {{ filterValue | label(filters) }}
        </button>
      </li>
    </button>
    <button
      role="group"
      class="c-active-filters-group"
      aria-label="gender"
    >
      <li
        v-for="(filterValue, key) in filterValues.gender"
        :key="`${key}`"
        aria-required="true"
        class="c-active-filters__filter"
      >
        <button
          class="c-active-filters__pill t-heading-9"
          @click="removeFilter(filterValue)"
        >
          {{ filterValue | label(filters) }}
        </button>
      </li>
    </button>
  </ul>
</template>

<script>
import isArray from 'lodash/isArray'
import capitalize from 'lodash/capitalize'

export default {
  name: 'ActiveFilter',
  filters: {
    label(filter, filters) {
      let filterLabel = ''
      let filterValue = filter.value
      for (let item of filters) {
        const { field, label } = item.property
        if (filter.property === field) {
          filterLabel = label
          break
        }
      }
      if (filter.value.includes(':')) {
        if (filterLabel) {
          filterValue = filter.value.split(':')[1]
        } else {
          [filterLabel, filterValue] = filter.value.split(':')
          filterLabel = capitalize(filterLabel)
        }
      }
      return `${filterLabel}: ${filterValue}`
    }
  },
  props: {
    filters: {
      type: Array,
      default: () => []
    },
    activeFilters: {
      type: Array,
      default () { return [] }
    }
  },
  computed: {
    filterLabelsByProperty() {
      let index = {}
      for (let filter of this.filters) {
        const { field, label } = filter.property
        index[field] = label
      }
      return index
    },
    filterValues() {
      let result = []
      for (let filter of this.activeFilters) {
        result[filter.property] = []
        if (isArray(filter.values)) {
          for (let value of filter.values) {
            result[filter.property].push({
              property: filter.property,
              value
            })
          }
        }
      }
      return result
    }
  },
  methods: {
    removeFilter (filter) {
      this.$emit('input', filter)
    }
  }
}
</script>

<style lang="scss" scoped>
.c-active-filters {
  padding: $filter-padding;
  width: 100%;
  &-group {
    border: 0px;
    @include themify($themes) {
      background: themed('background', 'base');
    }
  }
  &__filter {
    margin: rem(10px) rem(20px) rem(10px) 0;
    list-style-type: none;
  }
  &__pill {
    cursor: pointer;
    padding: 5px 30px 5px 15px;
    border-radius: rem(20px);
    position: relative;
    background-color: transparent;
    &:after {
      transform: translate(-15px, -50%) rotate(45deg);
    }
    &:before {
      transform: translate(-15px, -50%) rotate(-45deg);
    }
    &:after, &:before {
      content: '';
      width: 1px;
      height: 12px;
      position: absolute;
      top: 50%;
      right: 0;
      @include themify($themes) {
        background-color: themed('foreground');
      }
    }
    @include themify($themes) {
      border: 1px solid themed('foreground', 'light');
    }
  }
}
</style>
